<template>
  <div v-if="cart" class="cart">
    <div class="cart-icon" :class="shakeEffect"
      @mouseover="showCart()"
      @click="gotoAccount()">
      <div class="cart-svg-container">
        <img :src="require('images/cart.svg')" />
        <span v-show="cartCount > 0" class="badge badge-pill badge-warning" :class="{ 'large-number': cartCount >= 100, 'medium-number': cartCount >= 10 && cartCount < 100 }">{{cartCount}}</span>
        <span v-show="order && cart && cartCount == 0 && orderTotal > 0" class="badge badge-pill badge-ok">
          <i class="fas fa-check"></i>
        </span>
      </div>
    </div>
    <div class="text-center" v-if="cart && cartCount > 0">
      <span class="amount color-red">{{(cartTotal + glassTotal) | formatIntAmount}}</span>
      <span class="currency color-red">FCFA</span>
      <div class="hint-icon-container" v-if="glassTotal > 0">
        <button class="hint-icon-button"
           @mouseenter="hoverHint"
           @mouseleave="leaveHint"
           @click="toggleHint">
          <i class="fas fa-recycle hint-icon"></i>
        </button>
        <div v-if="showHint" class="hint-popover" @mouseenter="hoverPopover" @mouseleave="leavePopover">
          <div class="hint-content">
            <i class="fas fa-recycle hint-recycle-icon"></i>
            <span class="hint-text">Ce montant inclut <strong>({{glassTotal | formatIntAmount}} f)</strong> de consigne remboursable</span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-if="order && cart && cartCount == 0 && orderTotal > 0">
      <span class="amount color-primary">{{(orderTotal + orderGlassTotal) | formatIntAmount}}</span>
      <span class="currency color-primary">FCFA</span>
      <div class="hint-icon-container" v-if="orderGlassTotal > 0">
        <button class="hint-icon-button"
           @mouseenter="hoverHintOrder" 
           @mouseleave="leaveHintOrder"
           @click="toggleHintOrder">
          <i class="fas fa-recycle hint-icon"></i>
        </button>
        <div v-if="showHintOrder" class="hint-popover" @mouseenter="hoverPopoverOrder" @mouseleave="leavePopoverOrder">
          <div class="hint-content">
            <i class="fas fa-recycle hint-recycle-icon"></i>
            <span class="hint-text">Ce montant inclut <strong>({{orderGlassTotal | formatIntAmount}} f)</strong> de consigne remboursable</span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center orderDate" v-if="order && cart && cartCount == 0 && orderTotal > 0">
      <span class="color-primary">{{order.date | formatMonth}}</span>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="cartCount > 0" v-show="showContent" @mouseleave="hideCart()" class="cart-content">
        <div class="row cart-items">
          <cart-box-item v-for="item in cartBoxes" :key="item.id" :item="item" />
          <cart-item v-for="item in cartProducts" :key="item.id" :item="item" :with-likes="authenticated" :likes="likes" />
        </div>
        <div class="row cart-total border-top border-bottom mt-4 justify-content-center">
          <span class="amount">{{(cartTotal + glassTotal) | formatIntAmount}}</span>
          <span class="currency">FCFA</span>
          <div class="hint-icon-container" v-if="glassTotal > 0">
            <button class="hint-icon-button"
               @mouseenter="hoverHintContent" 
               @mouseleave="leaveHintContent"
               @click="toggleHintContent">
              <i class="fas fa-recycle hint-icon"></i>
            </button>
            <div v-if="showHintContent" class="hint-popover" @mouseenter="hoverPopoverContent" @mouseleave="leavePopoverContent">
              <div class="hint-content">
                <i class="fas fa-recycle hint-recycle-icon"></i>
                <span class="hint-text">Ce montant inclut <strong>({{glassTotal | formatIntAmount}} f)</strong> de consigne remboursable</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row py-3 mx-5">
          <a @click="gotoAccount()" class="btn btn-primary btn-lg btn-block">Continuer</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import services from './packs/services'
import eventBus from './packs/eventBus'

export default {
  data: function () {
    return {
      shakeEffect: "",
      items: [],
      likes: [],
      cart: null,
      order: null,
      showContent: false,
      authenticated: false,
      loading: false,
      showHint: false,
      hintClicked: false,
      showHintContent: false,
      hintContentClicked: false,
      showHintOrder: false,
      hintOrderClicked: false
    }
  },
  mounted() {
    this.refresh()
    eventBus.$on('OrderNeedValidation', function() {
      this.refresh()
      this.shake()
    }.bind(this))

    eventBus.$on('OrderValidated', function() {
      this.refresh()
    }.bind(this))

    eventBus.$on('OrderUpdated', function() {
      this.refresh()
    }.bind(this))

    // Close hint when clicking outside
    document.addEventListener('click', this.closeHintOnClickOutside)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeHintOnClickOutside)
  },

  computed: {

    unValidated() {
      return this.unValidatedProducts.length > 0
    },

    unValidatedProducts() {
      return this.cart.order_items
    },

    cartProducts() {
      return this.items.filter(item => !item.panier)
    },

    cartBoxes() {
      return this.items.filter(item => item.panier)
    },

    cartCount() {
      return this.items.length
    },

    cartTotal() {
      let total = 0
      this.items.forEach(item => {
        let price = 0
        if (item.panier) {
          price = item.box.price
        }else {
          price = item.product.price
        }
        total += item.quantity * price
      });
      return total
    },

    orderTotal() {
      let total = 0
      this.order.order_items.forEach(item => {
        total += item.quantity * item.price
      });
      return total
    },

    glassTotal() {
      let total = 0
      this.items.forEach(item => {
        if (item.glass_amount) {
          total += item.glass_amount
        }
      });
      return total
    },

    orderGlassTotal() {
      let total = 0
      if (this.order && this.order.order_items) {
        this.order.order_items.forEach(item => {
          if (item.glass_amount) {
            total += item.glass_amount
          }
        });
      }
      return total
    },
  },

  methods: {

    showCart() {
      this.showContent = true
    },

    hideCart() {
      this.showContent = false
    },

    async refresh() {
      this.loading = true
      let user = await services.getCurrentUser()
      if(user.id) {
        this.authenticated = true
        this.order = await services.getCartContent()
      }
      this.likes = await services.getLikes()
      this.cart = await services.getTCartContent()
      this.items = this.cart.order_items
      this.loading = false
    },

    shake() {
      this.shakeEffect = "shake-hard shake-constant"
      setTimeout(() => {
        this.shakeEffect = ""
      }, 500)
    },

    gotoAccount() {
      if(this.authenticated){
        if (this.unValidated) {
          window.location.href = '/my-cart'
        } else {
          window.location.href = '/account'
        }
      }else {
        window.location.href = '/cart/recap'
      }
    },

    toggleHint() {
      this.hintClicked = !this.hintClicked
      this.showHint = this.hintClicked
    },

    hoverHint() {
      if (!this.hintClicked) {
        this.showHint = true
      }
    },

    leaveHint() {
      if (!this.hintClicked) {
        this.showHint = false
      }
    },

    hoverPopover() {
      this.showHint = true
    },

    leavePopover() {
      if (!this.hintClicked) {
        this.showHint = false
      }
    },

    closeHintOnClickOutside(event) {
      if (this.hintClicked && !event.target.closest('.hint-icon-container')) {
        this.hintClicked = false
        this.showHint = false
      }
      if (this.hintContentClicked && !event.target.closest('.hint-icon-container')) {
        this.hintContentClicked = false
        this.showHintContent = false
      }
      if (this.hintOrderClicked && !event.target.closest('.hint-icon-container')) {
        this.hintOrderClicked = false
        this.showHintOrder = false
      }
    },

    toggleHintContent() {
      this.hintContentClicked = !this.hintContentClicked
      this.showHintContent = this.hintContentClicked
    },

    hoverHintContent() {
      if (!this.hintContentClicked) {
        this.showHintContent = true
      }
    },

    leaveHintContent() {
      if (!this.hintContentClicked) {
        this.showHintContent = false
      }
    },

    hoverPopoverContent() {
      this.showHintContent = true
    },

    leavePopoverContent() {
      if (!this.hintContentClicked) {
        this.showHintContent = false
      }
    },

    toggleHintOrder() {
      this.hintOrderClicked = !this.hintOrderClicked
      this.showHintOrder = this.hintOrderClicked
    },

    hoverHintOrder() {
      if (!this.hintOrderClicked) {
        this.showHintOrder = true
      }
    },

    leaveHintOrder() {
      if (!this.hintOrderClicked) {
        this.showHintOrder = false
      }
    },

    hoverPopoverOrder() {
      this.showHintOrder = true
    },

    leavePopoverOrder() {
      if (!this.hintOrderClicked) {
        this.showHintOrder = false
      }
    }

  }
}
</script>

<style lang='scss' scoped>

.orderDate {
  border-top: solid 1px #2A6336;
  span{
    font-size: 11px;
  }
}

.cart {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}

.cart-icon {
  cursor: pointer;
  width: 80px;
  position: relative;
  display: inline-block;
}

.cart-svg-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.cart-content {
  padding: 10px 15px;
  position: absolute;
  top: 88px;
  right: 0px;
  width: 400px;
  margin-right: -25px;
  background-color:#F4F3F0;
}

.cart-items {
  max-height: 330px;
  overflow-y: auto;
  margin: 0;
}

.cart-total {
  height: 60px;
  line-height: 60px;
}

.cart-total .amount {
  font-size: 16px;
}
.cart-total .currency {
  font-size: 12px;
  margin-left: 5px;
}

.cart-svg-container .badge {
  position: absolute;
  top: -10px;
  right: 5px;
  font-size: 13px;
  min-width: 25px;
  height: 25px;
  line-height: 20px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 50%;

  // For double-digit numbers (10-99), make it slightly oval
  &.medium-number {
    border-radius: 15px;
    min-width: 28px;
    padding: 0 5px;
    top: -12px;
    right: 2px;
  }

  // For very large numbers (100+), make it smaller and more compact
  &.large-number {
    font-size: 11px;
    min-width: 32px;
    padding: 0 6px;
    border-radius: 16px;
    top: -12px;
    right: 2px;
  }
}

.badge-warning {
  color: #FFF;
  background-color: #E97834;
}

.badge-ok {
  color: #FFF;
  background-color: #2A6336;
}

.card {
  width: auto;
  height: 102px;
}

.card-body {
  padding: 10px 10px;
}

.card-body-title {
  height: 60px;
}

.card-title {
  margin-bottom: 5px;
}

.card-text-price {
  font-size: 10px;
}

.cart-item {
  margin-bottom: 10px;
  background-color:#fff;
}

.cart-item img {
  width: 100%;
  height: auto;
  min-height: 100px;
  object-fit: cover;
  border-radius: 0px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.amount {
  font-family: 'ITC Souvenir Std Demi';
  font-size: 12px;
}

.currency {
  font-family: 'Montserrat';
  font-size: 10px;
}

.hint-icon-container {
  position: relative;
  display: inline-block;
  margin-left: 5px;
}

.hint-icon-button {
  background: #28a745;
  border: 1px solid #20c997;
  padding: 2px;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  outline: none;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
}

.hint-icon-button:focus {
  outline: none;
}

.hint-icon-button:active {
  transform: scale(0.95);
}

.hint-icon {
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: bold;
}

.hint-icon-button:hover {
  background: #218838;
  box-shadow: 0 3px 6px rgba(40, 167, 69, 0.4);
  transform: scale(1.05);
}

.hint-popover {
  position: absolute;
  top: -50px;
  right: 0;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  z-index: 1000;
  min-width: 280px;
  white-space: nowrap;
}

.hint-popover::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 15px;
  border: 8px solid transparent;
  border-top-color: #fff;
}

.hint-popover::before {
  content: '';
  position: absolute;
  top: 100%;
  right: 15px;
  border: 9px solid transparent;
  border-top-color: #e9ecef;
  margin-top: 1px;
}

.hint-content {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.hint-recycle-icon {
  color: #28a745;
  font-size: 18px;
  margin-right: 8px;
}

.hint-text {
  font-family: 'Montserrat', sans-serif;
  line-height: 1.4;
}

.hint-text strong {
  color: #28a745;
  font-weight: 600;
}


</style>
